<div class="pu-page bs">
  <div class="pu-head">
    <div class="pu-head__main">
      <h1 class="stk-page-title">Beszállítók</h1>
      <div class="stk-page-sub">Kitől és mit rendelünk — ezekből áll a rendelési lista.</div>
    </div>
    <button type="button" class="pu-btn pu-btn--dark" (click)="newSupplier()">+ Új beszállító</button>
  </div>

  <div class="pu-empty" *ngIf="loading">Betöltés…</div>

  <div class="bs-grid" *ngIf="!loading">
    <div class="pu-card pu-card--flush bs-list">
      <button type="button" class="bs-list__item" *ngFor="let s of suppliers" [class.bs-list__item--on]="s.id === selectedId" (click)="select(s.id)">
        <span class="bs-list__name">{{ s.name }}</span>
        <span class="pu-muted">{{ s.order_method === 'webshop' ? 'webshop' : 'e-mail' }} · {{ (s.items || []).length }} termék</span>
      </button>
      <div class="pu-empty" *ngIf="!suppliers.length">Még nincs beszállító.</div>
    </div>

    <div class="bs-detail" *ngIf="form">
      <div class="pu-card">
        <div class="pu-card__title">{{ selectedId ? form.name || 'Beszállító' : 'Új beszállító' }}</div>
        <div class="pu-grid bs-form">
          <label class="pu-field">Név <input class="pu-input" [(ngModel)]="form.name" placeholder="Fiorex Packaging Kft."></label>
          <label class="pu-field">Rendelés módja
            <select class="pu-input" [(ngModel)]="form.order_method">
              <option value="webshop">Webshop</option>
              <option value="email">E-mail</option>
            </select></label>
          <label class="pu-field">Weboldal <input class="pu-input" [(ngModel)]="form.website" placeholder="https://www.fiorex.hu"></label>
          <label class="pu-field">E-mail <em>{{ form.order_method === 'email' ? '(ide megy a rendelés)' : '(kérdésekhez)' }}</em>
            <input class="pu-input" [(ngModel)]="form.email" placeholder="ugyfelszolgalat@…"></label>
          <label class="pu-field">Kapcsolattartó <input class="pu-input" [(ngModel)]="form.contact_name"></label>
          <label class="pu-field">Fizetés <input class="pu-input" [(ngModel)]="form.payment_method" placeholder="utánvét"></label>
          <label class="pu-field bs-gross"><span><input type="checkbox" [(ngModel)]="form.prices_gross"> Az árak bruttók</span> <em>(vevői webshop, ÁFA-val)</em></label>
          <label class="pu-field">Levél nyelve
            <select class="pu-input" [(ngModel)]="form.language">
              <option value="hu">magyar</option>
              <option value="en">angol</option>
              <option value="de">német</option>
            </select></label>
          <label class="pu-field">Szállítási díj <em>(Ft, becsléshez)</em> <input class="pu-input" type="number" min="0" [(ngModel)]="form.shipping_fee_huf"></label>
          <label class="pu-field">Minimális rendelés <em>(Ft)</em> <input class="pu-input" type="number" min="0" [(ngModel)]="form.min_order_huf"></label>
          <label class="pu-field">Szállítási idő <em>(nap)</em> <input class="pu-input" type="number" min="0" [(ngModel)]="form.lead_time_days"></label>
        </div>
        <label class="pu-field bs-note">Megjegyzés Foxinak <em>(pl. „25-ös kötegben árulják”, „hétfőn rendelve szerdára ér ide”)</em>
          <textarea class="pu-input" rows="2" [(ngModel)]="form.note"></textarea></label>
        <div class="bs-actions">
          <button type="button" class="pu-btn pu-btn--sm pu-btn--danger" *ngIf="selectedId" (click)="removeSupplier()">Törlés</button>
          <button type="button" class="pu-btn pu-btn--sm" *ngIf="selectedId" (click)="archive()">Archiválás</button>
          <button type="button" class="pu-btn pu-btn--accent" (click)="saveSupplier()" [disabled]="saving">{{ saving ? 'Mentés…' : 'Mentés' }}</button>
        </div>
      </div>

      <div class="pu-card pu-card--flush" *ngIf="selected">
        <div class="bs-items__head">
          <span class="pu-card__title">Termékek</span>
          <button type="button" class="pu-btn pu-btn--sm" (click)="editItem()">+ Termék</button>
        </div>

        <div class="bs-item-form" *ngIf="itemForm">
          <div class="pu-grid">
            <label class="pu-field">Megnevezés <input class="pu-input" [(ngModel)]="itemForm.name" placeholder="A18 doboz 200×150×150"></label>
            <label class="pu-field">Webshop-link <input class="pu-input" [(ngModel)]="itemForm.url" placeholder="https://…"></label>
            <label class="pu-field">Cikkszám <input class="pu-input" [(ngModel)]="itemForm.supplier_sku" placeholder="FIO-1585"></label>
            <label class="pu-field">{{ form.prices_gross ? 'Bruttó' : 'Nettó' }} ár <em>(Ft / webshop-egység)</em> <input class="pu-input" type="number" min="0" step="0.01" [(ngModel)]="itemForm.unit_price_huf"></label>
            <label class="pu-field">Kiszerelés <em>(db/köteg)</em> <input class="pu-input" type="number" min="1" [(ngModel)]="itemForm.pack_size"></label>
            <label class="pu-field">Szokásos rendelés <em>(db)</em> <input class="pu-input" type="number" min="1" [(ngModel)]="itemForm.usual_qty"></label>
          </div>
          <div class="bs-actions">
            <span class="pu-muted" *ngIf="itemForm.url">Mentés után az „Ár a webshopból” gomb kitölti az árat.</span>
            <button type="button" class="pu-btn" (click)="itemForm = null">Mégse</button>
            <button type="button" class="pu-btn pu-btn--accent" (click)="saveItem()" [disabled]="itemSaving">{{ itemSaving ? 'Mentés…' : 'Termék mentése' }}</button>
          </div>
        </div>

        <div class="bs-item" *ngFor="let i of selected.items" [class.bs-item--off]="!i.active">
          <div class="bs-item__main">
            <div class="bs-item__name">
              <a *ngIf="i.url; else plain" [href]="i.url" target="_blank" rel="noopener">{{ i.name }}</a><ng-template #plain>{{ i.name }}</ng-template>
              <span class="pu-pill" *ngIf="!i.active">nem figyeljük</span>
            </div>
            <div class="pu-muted">
              {{ i.supplier_sku || 'nincs cikkszám' }}
              · {{ price(i) !== null ? (price(i) | number:'1.0-2') + ' Ft/db' : 'nincs ár' }}
              <ng-container *ngIf="i.price_checked_at"> ({{ i.price_checked_at | date:'MMM d.' }})</ng-container>
              <ng-container *ngIf="i.pack_size"> · {{ i.pack_size }}-ös köteg</ng-container>
              · szokásos: {{ i.usual_qty || '—' }} db
            </div>
          </div>
          <div class="bs-item__actions">
            <button type="button" class="pu-btn pu-btn--sm" *ngIf="i.url" (click)="checkPrice(i)" [disabled]="checking[i.id]">{{ checking[i.id] ? '…' : 'Ár a webshopból' }}</button>
            <button type="button" class="pu-btn pu-btn--sm" (click)="editItem(i)">Szerkesztés</button>
            <button type="button" class="pu-btn pu-btn--sm" (click)="toggleActive(i)">{{ i.active ? 'Kivétel a listáról' : 'Vissza a listára' }}</button>
            <button type="button" class="pu-btn pu-btn--sm pu-btn--danger" (click)="deleteItem(i)">Törlés</button>
          </div>
        </div>
        <div class="pu-empty" *ngIf="!(selected.items || []).length && !itemForm">Még nincs termék — add hozzá a dobozokat, fóliát, mágnest…</div>
      </div>
    </div>

    <div class="pu-card pu-empty" *ngIf="!form">Válassz beszállítót, vagy vegyél fel újat.</div>
  </div>
</div>
